import { Component, OnInit, Input } from '@angular/core';
import { QuoteService } from 'src/app/quote/quote.service';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-ag-financials',
  templateUrl: './ag-financials.component.html',
  styleUrls: ['./ag-financials.component.css', '../../../quote.component.css']
})
export class AgFinancialsComponent implements OnInit {
  premium: any = '{"referred": null,"ipt": 0,"gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"vehicle_excesses": {},"driver_excesses": [],"compulsory_excess": 0}';
  vehicle_premiums_key: string = '';
  vehicle_premiums_value: number = 0;
  gross_premium: number = 0;
  commission: number = 0;
  total_amount: number = 0;
  peliwica_fee: number = 0;
  broker_admin_fee: number = 0;
  total_prem_inc_ipt: number = 0;
  quote;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.premium = value.premium;
      this.commission = value.commission;
      this.peliwica_fee = value.peliwica_fee;
      this.broker_admin_fee = value.broker_admin_fee;
      if (value.premium) {
        this.gross_premium = Number(value.premium.gross);
        this.total_prem_inc_ipt = Number(value.premium.gross);
        if (value.is_send_email == 1) {
          this.total_amount = this.gross_premium + Number(this.peliwica_fee) + Number(this.broker_admin_fee);
        } else {
          this.total_amount = this.gross_premium + Number(this.peliwica_fee);
        }
      }
      if (value.premium && value.premium.vehicle_premiums) {
        this.vehicle_premiums_key = Object.keys(value.premium.vehicle_premiums)[0];
        this.vehicle_premiums_value = Number(Object.values(value.premium.vehicle_premiums)[0]);
      }
    }
  }
  constructor(private quoteService: QuoteService, private sessionSt: LocalStorageService) { }

  ngOnInit(): void {
  }

  getPeliwicaPremium() {
    this.quoteService.getLiveStockBrokerCommission(this.sessionSt.retrieve('userInfo').company_id, environment.AGRIMOTOR_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.peliwica_fee = response.result.broker_admin_fee;
          }
        },
        (error) => { }
      );
  }

}
